// extracted by mini-css-extract-plugin
export default {"description":"styles_description__b-u5j","locationContainer":"styles_locationContainer__kxm+c"};